import React from 'react';
import { Leaf, Tag, CheckCircle2 } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { ProductSection, BulkPackagingGrid, InfoCard } from './ProductShared';

const OliveOilDetail = ({ product }) => {
  if (!product.oliveOilTypes) return null;

  return (
    <div className="mt-8 space-y-10">
      <InfoCard icon={Leaf} title="Why Olive Oil?">
        <p className="text-gray-700 leading-relaxed">
          Olive oil is one of the healthiest fats available. Rich in monounsaturated fatty acids and powerful antioxidants like polyphenols, it helps reduce inflammation, supports cardiovascular health, and lowers the risk of chronic disease. A staple of the Mediterranean diet, olive oil has been prized for centuries — not just for its exceptional flavor, but for its proven health benefits.
        </p>
      </InfoCard>

      <ProductSection title="Our Olive Oil Range" icon={Leaf}>
        <div className="grid md:grid-cols-2 gap-4">
          {product.oliveOilTypes.map((oil) => (
            <Card key={oil.name} className="border-2 hover:border-green-400 transition-colors">
              <CardContent className="p-5">
                <div className="flex items-start">
                  <CheckCircle2 className="w-5 h-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" />
                  <div>
                    <h5 className="font-semibold text-gray-900 mb-1">{oil.name}</h5>
                    <p className="text-sm text-gray-600">{oil.desc}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </ProductSection>

      <ProductSection title="Sunterra Olive Oil Products" icon={Tag}>
        <div className="grid md:grid-cols-2 gap-6">
          {product.retailImages.map((img) => (
            <Card key={img.alt} className="overflow-hidden border-2 hover:shadow-xl transition-all">
              <div className="relative h-80 bg-white">
                <img src={img.src} alt={img.alt} className="w-full h-full object-contain p-4" />
              </div>
              <CardContent className="p-4 text-center">
                <p className="text-sm font-medium text-gray-700">{img.alt}</p>
              </CardContent>
            </Card>
          ))}
        </div>
      </ProductSection>

      <BulkPackagingGrid packages={product.packaging.bulk} />

      <Card className="bg-gradient-to-br from-blue-50 to-indigo-50 border-2 border-blue-200">
        <CardContent className="p-8">
          <div className="text-center">
            <h4 className="text-2xl font-bold text-gray-900 mb-3">Private Label Available</h4>
            <p className="text-gray-700 leading-relaxed max-w-2xl mx-auto mb-6">
              We offer full private label and OEM services for all olive oil grades. Launch your own branded olive oil line with our premium olive oils from Turkiye and Spain — customized packaging, labeling, and formulations tailored to your market.
            </p>
            <div className="grid md:grid-cols-3 gap-4 max-w-3xl mx-auto">
              {['Custom Branding', 'Flexible MOQ', 'All Grades Available'].map((item) => (
                <div key={item} className="bg-white rounded-xl p-4 shadow-md">
                  <CheckCircle2 className="w-6 h-6 text-blue-600 mx-auto mb-2" />
                  <p className="text-sm font-medium text-gray-900">{item}</p>
                </div>
              ))}
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OliveOilDetail;
